/**
 * What the selected supplier has on their bench.
 *
 * Sits under their accounts because that is the question the screen raises:
 * having given someone a login, is anything actually waiting on them? Open
 * orders by default — the closed ones are history, and history is what the
 * orders screen is for — with a filter for the times someone asks about a job
 * that has already shipped.
 */
define('portalOrdersView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'jquery',
  'dateUtils',
  'template!portalOrdersTpl',
  'entities/suppliers/portal_users'
], function (
  Module,
  Marionette,
  _,
  App,
  $,
  DateConverter,
  ordersTpl
) {
  'use strict';

  /** The supplier's own words for each status, not the enum's. */
  function statusLabel(status) {
    switch (status) {
      case 'RECEIVED': return _.i18n('portalOrders.status.received', null, 'Received');
      case 'ACCEPTED': return _.i18n('portalOrders.status.accepted', null, 'Accepted');
      case 'IN_PRODUCTION': return _.i18n('portalOrders.status.inProduction', null, 'In production');
      case 'READY_TO_SHIP': return _.i18n('portalOrders.status.readyToShip', null, 'Ready to ship');
      case 'SHIPPED': return _.i18n('portalOrders.status.shipped', null, 'Shipped');
      case 'REJECTED': return _.i18n('portalOrders.status.rejected', null, 'Rejected');
      case 'CANCELLED': return _.i18n('portalOrders.status.cancelled', null, 'Cancelled');
      default: return status;
    }
  }

  Module.exports = Marionette.ItemView.extend({
    template: ordersTpl,
    className: 'portal-orders-view',

    ui: {
      scope: '.js-scope',
      page: '.js-page'
    },

    events: {
      'click @ui.scope': 'onScope',
      'click @ui.page': 'onPage',
      'click .js-conversation': 'onConversation'
    },

    initialize: function (options) {
      this.orders = options.orders || [];
      this.scope = options.scope || 'open';
      this.failed = options.failed === true;
      this.total = options.total || 0;
      this.start = options.start || 0;
      this.pageSize = options.pageSize || 15;
    },

    serializeData: function () {
      var now = new Date().getTime();

      var last = this.start + this.orders.length;

      return {
        scope: this.scope,
        failed: this.failed,
        empty: this.orders.length === 0,
        // 1-based for the reader; the offset stays 0-based on the wire.
        first: this.start + 1,
        last: last,
        total: this.total,
        // A single page needs no controls at all — showing "1-4 of 4" next to
        // two dead arrows is noise on the common case.
        paged: this.total > this.orders.length || this.start > 0,
        hasPrevious: this.start > 0,
        hasNext: last < this.total,
        orders: _.map(this.orders, function (order) {
          return {
            secId: order.secId,
            // What the supplier wrote and nobody here has opened yet.
            unreadMessages: order.unreadMessages || 0,
            purchaseOrderId: order.purchaseOrderId,
            reference: order.reference,
            productCode: order.productCode,
            productName: order.productName,
            quantity: order.quantity,
            status: order.status,
            statusLabel: statusLabel(order.status),
            received: order.receivedAt ? DateConverter.toMDYHHMMFormat(order.receivedAt) : null,
            delivery: order.deliveryDate ? DateConverter.toDateFormatString(order.deliveryDate) : null,
            // Past its delivery date and still open: the one row on this list
            // that needs someone to do something today.
            late: order.deliveryDate && order.deliveryDate < now &&
              order.status !== 'SHIPPED' && order.status !== 'REJECTED' &&
              order.status !== 'CANCELLED',
            express: order.express === true,
            sample: order.sample === true,
            // Pushed to the portal and nobody has opened it yet.
            neverViewed: order.neverViewed === true
          };
        })
      };
    },

    onScope: function (event) {
      this.trigger('scope', $(event.currentTarget).data('scope'));
    },

    onConversation: function (event) {
      var secId = $(event.currentTarget).attr('data-secid');
      var order = _.find(this.orders, function (candidate) {
        return candidate.secId === secId;
      });
      if (order) {
        this.trigger('conversation', order);
      }
    },

    onPage: function (event) {
      var step = $(event.currentTarget).data('step') === 'next' ? this.pageSize : -this.pageSize;
      this.trigger('page', Math.max(0, this.start + step));
    }
  });
});

